module.exports = __webpack_public_path__ + "img/user-treatment-icon.2c1e9e17.svg";